import { DataSelectionContext } from './DataSelectionContext'
import useRequiredContext from '../../hooks/useRequiredContext'

const useDataSelection = () => useRequiredContext(DataSelectionContext)

export default useDataSelection
